<template>
  <div>
    <ContentSectionLoader v-show="!loaded" />
    <div
      v-show="loaded"
      class="flex flex-wrap justify-end my-2"
    >
      <div
        v-if="pagination.total"
        class="w-full sm:w-1/5"
      >
        <div class="input-group pt-3 pb-2 pl-3 sm:mr-8">
          <div>
            <input
              id="select-all"
              v-model="selectAll"
              type="checkbox"
              name="select-all"
            >
            <label
              for="select-all"
              v-text="'Select All'"
            />
          </div>
        </div>
      </div>
    </div>
    <Transition name="fade">
      <div v-show="loaded">
        <FormSubmissionList :loaded="loaded" />
        <Pagination
          v-if="loaded"
          :on-change="changePage"
          :pagination="pagination"
        />
      </div>
    </Transition>
    <div
      v-if="selectedSubmissions.length && !showConfirmModal"
      class="fixed text-center pin-x py-4 pin-b bg-grey-light border-t border-grey-dark"
      style="z-index: 1001;"
    >
      <button
        type="button"
        :class="{ load: !loaded }"
        class="btn btn-blue"
        @click.prevent="openConfirmationModal"
        v-text="submitButtonText"
      />
      <button
        v-if="loaded"
        class="mx-4 px-2"
        @click.prevent="handleResetSelection"
        v-text="'Clear Selection'"
      />
    </div>
    <ConfirmExportModal
      :open="showConfirmModal"
      @closeModal="closeConfirmationModal"
      @exportSubmissions="exportSelectedSubmissions"
    />
  </div>
</template>

<script type="text/babel">
import { mapActions, mapState } from 'vuex'
import FormSubmissionList from './FormSubmissionList'
import ConfirmExportModal from 'FormBuilder/Resources/assets/js/components/_modals/ConfirmExportModal'

export default {
  name: 'FormSubmissions',
  components: {
    FormSubmissionList,
    ConfirmExportModal,
  },
  props: {
    formUuid: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loaded: false,
      selectAll: false,
      showConfirmModal: false,
    }
  },
  computed: {
    ...mapState({
      pagination: state => _.get(state.form.submissions, 'meta.pagination', {}),
      selectedSubmissions: state => state.form.selectedSubmissions,
    }),
    selectedSubmissionIds() {
      return this.selectedSubmissions.map(submission => submission.id)
    },
    submitButtonText() {
      return `Export Submissions (${this.selectedSubmissions.length})`
    },
  },
  watch: {
    selectAll() {
      this.selectAll ? this.formSelectAllFormSubmissions() : this.formResetSelectedFormSubmissions()
    },
  },
  mounted() {
    this.formGetSubmissions({
      formUuid: this.formUuid,
    }).then(() => {
      this.$emit('loaded')

      this.loaded = true

      this.formSetForm(this.formUuid)
    })
  },
  methods: {
    ...mapActions([
      'formGetSubmissions',
      'formSetForm',
      'formSelectAllFormSubmissions',
      'formDownloadSelectedFormSubmissions',
    ]),
    changePage(page) {
      this.loaded = false

      this.fetchSubmissions(page)
    },
    fetchSubmissions(page) {
      this.formGetSubmissions({
        formUuid: this.formUuid,
        page: page,
      }).then(() => {
        this.$emit('loaded')

        this.loaded = true
      })
    },
    formResetSelectedFormSubmissions() {
      this.$store.commit('formResetSelectedFormSubmissions')
    },
    handleResetSelection() {
      if (this.selectAll === false) {
        this.formResetSelectedFormSubmissions()
      } else {
        this.selectAll = false
      }
    },
    exportSelectedSubmissions(payload) {
      this.formDownloadSelectedFormSubmissions({
        parameters: {
          form_submission_ids: this.selectedSubmissionIds,
          format: payload.format,
        },
      })
    },
    openConfirmationModal() {
      this.showConfirmModal = true
    },
    closeConfirmationModal() {
      this.showConfirmModal = false
    },
  },
}
</script>
